(ns admin.events.activities
  (:require
   [potpuri.core :as pot]
   [kyber.events.utils :refer [add-auth base-uri kyber-event-fx kyber-event-db]]
   [kyber.utils :as ku]
   [admin.utils :refer [->admin-url]]
   [kyber.lib.kyber-eql :refer [defmutate]]
   [kyber.lib.kyber-db :as kyber-db]
   [kyber.kyber-db.activity-resource :as activity-resource]))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; get-activity
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activity-success
    {:description "Get activity success"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activity-success
  [{:keys [db]} [event-name
                 {:keys [curriculum-uuid
                         activity-uuid]}
                 response]]
  {:db (update-in db
                  [:curricula curriculum-uuid :activities activity-uuid]
                  merge
                  (ku/set-primary-learning-object response))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx :activities/get-activity-success get-activity-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activity-failure
    {:description "Get activities failure"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activity-failure
  [{:keys [db]} [event-name _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx :activities/get-activity-failure get-activity-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activity
    {:description "Get activities request"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activity
  [{:keys [db]} [event-name {:keys [curriculum-uuid
                                    activity-uuid]}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request {:name event-name
             :method :get
             :uri (base-uri db (str "/v1/admin/curricula/" curriculum-uuid
                                    "/activities/" activity-uuid))
             :response-format :json
             :headers (add-auth db)
             :on-success [:activities/get-activity-success
                          {:curriculum-uuid curriculum-uuid
                           :activity-uuid activity-uuid}]
             :on-failure [:activities/get-activity-failure]}})

(kyber-event-fx :activities/get-activity get-activity)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; get-activity-overview
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activitiy-overview-success
    {:description "Get activity overview success"
     :changelog
     [{:date "25MAR19"
       :event-version 0
       :data {}}]}))

(defn get-activity-overview-success
  [{:keys [db]} [event-name {:keys [activity-uuid curriculum-uuid poll-plo-score?]} overview]]
  (let [updated-db (update-in db [:curricula curriculum-uuid
                                  :activities activity-uuid]
                              #(assoc %
                                      :activity-overview overview
                                      :uuid activity-uuid))
        plo-score-updated? (-> updated-db
                               (get-in [:curricula curriculum-uuid
                                        :activities activity-uuid
                                        :activity-overview :steps 0
                                        :points-awarded])
                               (pos?))]
    (cond->
     {:db updated-db
      :dispatch-n [[:analytics/save-datapoint {:event event-name
                                               :event-version 0}]]}

      (and (true? poll-plo-score?)
           (not plo-score-updated?))
      (update :dispatch-n conj
              [:dispatch-in 2000
               :activities/get-activity-overview
               {:activity-uuid activity-uuid
                :curriculum-uuid curriculum-uuid
                :poll-plo-score? poll-plo-score?}]))))

(kyber-event-fx
 :activities/get-activity-overview-success
 get-activity-overview-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activitiy-overview-failure
    {:description "Get activity overview failure"
     :changelog
     [{:date "25Mar19"
       :event-version 0
       :data {}}]}))

(defn get-activity-overview-failure
  [{:keys [db]} [event-name _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx
 :activities/get-activity-overview-failure
 get-activity-overview-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activitiy-overview
    {:description "Get activity overview success"
     :changelog
     [{:date "25Mar19"
       :event-version 0
       :data {}}]}))

(defn get-activity-overview
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid poll-plo-score?]}]]
  {:db db
   :request {:name event-name
             :method :get
             :uri (base-uri db (str "/v2/admin/activities/"
                                    activity-uuid
                                    "/overview"))
             :response-format :json
             :headers (add-auth db)
             :on-success [:activities/get-activity-overview-success
                          {:activity-uuid activity-uuid
                           :curriculum-uuid curriculum-uuid
                           :poll-plo-score? poll-plo-score?}]
             :on-failure [:activities/get-activity-overview-failure]}
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx :activities/get-activity-overview get-activity-overview)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; get-activities
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activities-success
    {:description "Get activities success"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activities-success
  [{:keys [db]} [event-name {:keys [curriculum-uuid]} response]]
  (let [updated-activities (->> response
                             (map ku/set-primary-learning-object)
                             ku/coll->dictionary)]
    {:db (update-in db [:curricula curriculum-uuid :activities]
                   (fn [activities]
                     (merge-with merge
                                 (pot/filter-keys #(contains? updated-activities %) activities)
                                 updated-activities)))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx :activities/get-activities-success get-activities-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activities-failure
    {:description "Get activities failure"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activities-failure
  [{:keys [db]} [event-name _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx :activities/get-activities-failure get-activities-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-activities
    {:description "Get activities request"
     :changelog
     [{:date "11OCT18"
       :event-version 0
       :data {}}]}))

(defn get-activities
  [{:keys [db]} [event-name {:keys [curriculum-uuid]}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request {:name event-name
             :method :get
             :uri (base-uri db
                            (str "/v1/admin/curricula/" curriculum-uuid
                                 "/activities"))
             :response-format :json
             :headers (add-auth db)
             :on-success [:activities/get-activities-success
                          {:curriculum-uuid curriculum-uuid}]
             :on-failure [:activities/get-activities-failure]}})

(kyber-event-fx :activities/get-activities get-activities)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; redirect-external-activities
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(when ^boolean js/goog.DEBUG
  (def event-doc-redirect-external-activities
    {:description ""
     :changelog
     [{:date "19SEP19"
       :event-version 0
       :data {}}]}))

(defn redirect-external-activity
  [{:keys [db]} [_ {:keys [activity-uuid curriculum-uuid]}]]
  (let [{:keys [external-activity-link]}
        (get-in db [:curricula curriculum-uuid
                    :activities activity-uuid])]
    (cond-> {:db db}
      (some? external-activity-link)
      (assoc :nav-to (->admin-url {:curriculum-uuid curriculum-uuid})))))

(kyber-event-fx :activities/redirect-external-activity
                redirect-external-activity)

(when ^boolean js/goog.DEBUG
  (def event-doc-redirect-external-activities-kyber-db
    {:description "Forces a redirect to the CLP if the activity is an external activity"
     :changelog
     [{:date "14JUL21"
       :event-version 0
       :data {}}]}))

(defn redirect-external-activity-kyber-db
  [{:keys [db]} [_ {:keys [activity-uuid curriculum-uuid]}]]
  (let [{:activity/keys [external-activity-link]}
        (kyber-db/get-record db :activity activity-uuid)]
    (cond-> {}
      (some? external-activity-link)
      (assoc :nav-to (->admin-url {:curriculum-uuid curriculum-uuid})))))

(kyber-event-fx :activities/redirect-external-activity-kyber-db
                redirect-external-activity-kyber-db)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; update-activity-dashboards
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(when ^boolean js/goog.DEBUG
  (def event-doc-update-activity-dashboards-success
    {:description ""
     :changelog
     [{:date "05DEC19"
       :event-version 0
       :data {}}]}))

(defn update-activity-dashboards-success
  [{:keys [db]} [event-name
                 {:keys [on-success curriculum-uuid activity-uuid]}
                 activity]]
  {:db (assoc-in db
                 [:curricula curriculum-uuid :activities activity-uuid :looker]
                 (:looker activity))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]
                [:notifier/create-toast
                 {:message "Updated Dashboards"}]]
   :invoke on-success})

(kyber-event-fx :activities/update-activity-dashboards-success
                update-activity-dashboards-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-update-activity-dashboards-failure
    {:description ""
     :changelog
     [{:date "05DEC19"
       :event-version 0
       :data {}}]}))

(defn update-activity-dashboards-failure
  [{:keys [db]} [event-name _]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]
                [:notifier/create-toast
                 {:message "Failed to update dashboards."
                  :status :error}]]})

(kyber-event-fx :activities/update-activity-dashboards-failure
                update-activity-dashboards-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-update-activity-dashboards
    {:description ""
     :changelog
     [{:date "05DEC19"
       :event-version 0
       :data {}}]}))

(defn update-activity-dashboards
  [{:keys [db]} [event-name {:keys [payload
                                    close-form
                                    curriculum-uuid
                                    activity-uuid]}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request {:name event-name
             :method :put
             :uri (base-uri db (str "/v2/admin"
                                    "/activities/" activity-uuid
                                    "/dashboards"))
             :params payload
             :format :json
             :response-format :json
             :headers (add-auth db)
             :on-success [:activities/update-activity-dashboards-success
                          {:on-success close-form
                           :activity-uuid activity-uuid
                           :curriculum-uuid curriculum-uuid}]
             :on-failure [:activities/update-activity-dashboards-failure]}})

(kyber-event-fx :activities/update-activity-dashboards
                update-activity-dashboards)

;; Legacy ^
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; New ⌄

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; update-activity
;;
;; TODO Remove this once everyting is migrated to using the new state
;;      management patterns. The update-activity event below this one
;;      is the prefered method for updating an activity for views that
;;      rely on the activity being indexed by kyber-db
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Note: Below are the prefered activity events. The above will be removed in
;;       the future when the legacy state management pattern has been removed.
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn reset-primary-learning-object
  [db [_ {:activity/keys [uuid primary-learning-object]}]]
  (kyber-db/tx-record db
                      {:model :activity
                       :ident-key uuid}
                      {:activity/primary-learning-object
                       primary-learning-object}))

(kyber-event-db ::reset-primary-learning-object reset-primary-learning-object)

(defmutate create-activity-v2
  {:model-key :activity
   :mutation-symbol 'activity/create
   :event-namespace ::self
   :analytics-key :activities/create-activity
   :return-full-model true})

(defmutate update-activity-v2
  {:model-key :activity
   :mutation-symbol 'activity/update
   :event-namespace ::self
   :analytics-key :activities/update-activity
   :update-fn
   (fn [db _request {:activity/keys [primary-learning-object]
                     :as response}]
     (-> db
         (kyber-db/retract-ref
          {:model :activity
           :refs-key :activity/resources
           :ref-ident-key (activity-resource/->ident-key primary-learning-object)}
          (select-keys response [:activity/uuid]))
         (kyber-db/tx-record {:model :activity} response)))})

(defmutate delete-activity-v2
  {:model-key :activity
   :mutation-symbol 'activity/delete
   :event-namespace ::self
   :analytics-key :activities/delete-activity
   :update-fn (fn [db _request {activity-uuid :activity/uuid}]
                (kyber-db/retract-record db {:model :activity} {:activity/uuid activity-uuid}))})

(defmutate create-plo-version-and-update-activity
  {:model-key :activity
   :mutation-symbol 'activity/create-plo-version-and-update-activity
   :event-namespace ::self
   :analytics-key :activities/create-plo-version-and-update-activity
   :update-fn
   (fn [db _request {:activity/keys [primary-learning-object]
                     :as response}]
     (-> db
         (kyber-db/retract-ref
          {:model :activity
           :refs-key :activity/resources
           :ref-ident-key (activity-resource/->ident-key primary-learning-object)}
          (select-keys response [:activity/uuid]))
         (kyber-db/tx-record {:model :activity} response)))})
